"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconBuilder = void 0;
var interfaces_1 = require("./common/interfaces");
var utils_1 = require("./common/utils/utils");
/**
 * 图标组件构建器
 * @param lineName 横线格式名
 * @param render 图标渲染方法
 */
var IconBuilder = function (lineName, render) {
    var IconComponent = {
        name: lineName,
        props: ['size', 'type', 'color', 'strokeLinecap', 'strokeLinejoin'],
        computed: {
            renderData: function () {
                var colorProp = this.color;
                var iconType = this.type ||
                    interfaces_1.defaultIconConfig.type;
                var size = this.size ||
                    interfaces_1.defaultIconConfig.size;
                var strokeLinecap = this.strokeLinecap ||
                    interfaces_1.defaultIconConfig.strokeLinecap;
                var strokeLinejoin = this.strokeLinejoin ||
                    interfaces_1.defaultIconConfig.strokeLinejoin;
                var colorDesc = (0, interfaces_1.getColorDescription)(colorProp, iconType);
                return {
                    size: size,
                    colorDesc: colorDesc,
                    strokeLinecap: strokeLinecap,
                    strokeLinejoin: strokeLinejoin,
                };
            },
        },
        render: function (h) {
            var renderData = this.renderData;
            var classes = [
                (0, utils_1.createClsName)('icon'),
                (0, utils_1.createClsName)("icon-".concat(lineName)),
            ];
            var styles = {};
            if (renderData.size) {
                styles.fontSize = "".concat(renderData.size, "px");
            }
            return h('span', {
                class: classes.join(' '),
                style: styles,
                on: this.$listeners,
                attrs: this.$attrs,
                domProps: {
                    innerHTML: render(renderData),
                }
            });
        }
    };
    return IconComponent;
};
exports.IconBuilder = IconBuilder;
